import { Button } from '@material-ui/core';
import React, { useState } from 'react'
import logo from '../logo512.png';

const Searchbar = ({socket, versionNumber, onClientToggle, cookies}) => {
    const [url, setURL] = useState('')
    const [clientCount, setClientCount] = useState(1);

    let waitingForResponse = false;

    const api_key = 'AIzaSyCLLSFgQAdh3zByCRh_p_kn8kBkyFejedI';

    const onSubmit = async (e) => {
        e.preventDefault();

        let extractedID = '';
        let index = url.indexOf('youtube.com/');
        let index2 = url.indexOf('youtu.be/');
        let index3 = url.indexOf('youtube.com/shorts/');
        if(index3 > -1){
            extractedID = url.slice(index3+19, index3+30);
        }else if (index > -1) {
            let vi = url.indexOf('v=')+2;
            extractedID = url.slice(vi, vi+11);
        }else if (index2 > -1){
            extractedID = url.slice(index2+9, index2+20);
        }
        if (extractedID !='') {
            let vidJSON = await fetch('https://www.googleapis.com/youtube/v3/videos?part=id%2Csnippet&id='+extractedID+'&key='+api_key)
                .then(data => data.json())
            try {
                socket.emit('queueVideo', {videoID: extractedID, title: vidJSON.items[0].snippet.localized.title, queuedBy: cookies['rave_username']})
                console.log('Requesting to queue: '+url)
                waitingForResponse = true;
            } catch (Error) {
                console.log('Queue Failed: Bad URL Given')
                console.error(Error)
            }
        }
    }

    if (socket != null) {
        socket.on('queueResponse', res => {
            if(waitingForResponse) {
                waitingForResponse = false;
                if (res.accepted) {
                        setURL('');
                        console.log('Queue success. Clearing field')
                }else{
                    console.log('Queue failed. Check URL')
                }
            }
        });
        socket.on("updateClientCount", (res) => {
            setClientCount(res);
        });
    }


    return (
        <>
            <div className='Header'>

                <table style={{width:'100%'}}>
                    <tbody>
                        <tr>
                            <th>
                                <img className='Logo' src={logo} height='36px' title={'The Rave '+versionNumber}/>
                                <h1 className='Title'>The Rave</h1>
                            </th>
                            <th>
                                <form style={{display: 'flex', 'align-items': 'center', width: '100%'}}>
                                    <input type={'text'} className='TextField' placeholder="Youtube URL" size="small" variant='filled' value={url} autoComplete="off" onKeyPress={(e)=>{
                                        if(e.code == 'Enter') {
                                            onSubmit(e)
                                        }
                                    }} onChange={(e)=>{
                                        setURL(e.target.value)
                                    }}/>
                                    <Button className='ui-button' style={{backgroundColor: '#D20000'}} variant="contained" color='secondary' disableElevation onClick={onSubmit}>Add</Button>
                                </form>
                            </th>
                            <th>
                                <div className={'ClientIndicator' + (cookies['rave_username'] && cookies['rave_username'] !== '' ? '':' ClientIndicatorFlash')} onClick={onClientToggle} style={{cursor: "pointer"}}>
                                    <h3>{clientCount}</h3>
                                </div>
                            </th>
                        </tr>
                    </tbody>
                </table>
                <hr />
            </div>
        </>

    )
}

export default Searchbar;